import React, { useState, useRef } from "react";
import {
  PlusCircle,
  Trash2,
  Search,
  Loader,
  Users,
  Star,
  Upload,
  RefreshCw,
  AlertTriangle,
} from "lucide-react";
import * as api from "../api/ligaApi";

const AdminPanel = ({
  duplas,
  desafioId,
  onAddDupla,
  onRemoveDupla,
  onAddTime,
  onRemoveTime,
  onSetCaptain,
  onUploadLogo,
  onFetchScores,
  onUpdateAllTimes,
  onResetScores,
  onResetScoresForRound,
}) => {
  const [newDuplaName, setNewDuplaName] = useState("");
  const [searchQueries, setSearchQueries] = useState({});
  const [searchResults, setSearchResults] = useState({});
  const [isSearching, setIsSearching] = useState({});
  const [searchErrors, setSearchErrors] = useState({});
  const fileInputRefs = useRef({});
  const [rodadaAdmin, setRodadaAdmin] = useState(1);
  const [isFetchingScores, setIsFetchingScores] = useState(false);
  const [isUpdatingTeams, setIsUpdatingTeams] = useState(false);

  const handleFetchScoresClick = async () => {
    setIsFetchingScores(true);
    await onFetchScores(rodadaAdmin);
    setIsFetchingScores(false);
  };

  const handleUpdateTeamsClick = async () => {
    setIsUpdatingTeams(true);
    await onUpdateAllTimes();
    setIsUpdatingTeams(false);
  };

  const handleAddDuplaSubmit = (e) => {
    e.preventDefault();
    if (newDuplaName.trim()) {
      onAddDupla(newDuplaName);
      setNewDuplaName("");
    }
  };

  const handleSearchSubmit = async (e, duplaId) => {
    e.preventDefault();
    const query = searchQueries[duplaId];
    if (!query) return;
    setIsSearching((prev) => ({ ...prev, [duplaId]: true }));
    setSearchErrors((prev) => ({ ...prev, [duplaId]: "" }));
    try {
      const results = await api.searchCartolaTimes(query);
      setSearchResults((prev) => ({ ...prev, [duplaId]: results }));
    } catch (err) {
      setSearchErrors((prev) => ({ ...prev, [duplaId]: err.message }));
    } finally {
      setIsSearching((prev) => ({ ...prev, [duplaId]: false }));
    }
  };

  const handleAddTimeClick = async (duplaId, timeDaApi) => {
    const timeDataFormatado = {
      nome_time: timeDaApi.nome,
      nome_cartoleiro: timeDaApi.nome_cartola,
      escudo_url: timeDaApi.url_escudo_png,
      cartola_time_id: timeDaApi.time_id,
      slug: timeDaApi.slug,
    };
    await onAddTime(duplaId, timeDataFormatado);
    setSearchQueries((prev) => ({ ...prev, [duplaId]: "" }));
    setSearchResults((prev) => ({ ...prev, [duplaId]: [] }));
  };

  const handleLogoButtonClick = (duplaId) => {
    fileInputRefs.current[duplaId].click();
  };

  const handleFileChange = (e, duplaId) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("logo", file);
      onUploadLogo(duplaId, formData);
    }
  };

  return (
    <div>
      <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-teal-400">
        Painel de Administração
      </h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-gray-800 p-4 sm:p-6 rounded-lg shadow-lg">
          <h3 className="text-xl font-bold mb-4 text-white">
            Gerir Duplas e Times
          </h3>
          <form
            onSubmit={handleAddDuplaSubmit}
            className="flex items-center space-x-2 mb-6"
          >
            <input
              type="text"
              value={newDuplaName}
              onChange={(e) => setNewDuplaName(e.target.value)}
              placeholder="Nome da Nova Dupla"
              className="flex-grow bg-gray-700 text-white p-2 rounded-md text-sm sm:text-base"
            />
            <button
              type="submit"
              className="bg-teal-600 hover:bg-teal-700 text-white font-bold p-2 rounded-lg flex items-center"
            >
              <PlusCircle size={18} />
            </button>
          </form>
          <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
            {duplas.map((dupla) => (
              <div key={dupla.id} className="bg-gray-900/70 p-4 rounded-lg">
                <div className="flex justify-between items-center mb-3">
                  <div className="flex items-center gap-3">
                    <img
                      src={api.getEscudoUrl(dupla.logo_url) || "/pair-icon.png"}
                      alt="Logo"
                      className="w-10 h-10 rounded-full object-contain bg-gray-700"
                    />
                    <h4 className="text-lg font-bold text-teal-300">
                      {dupla.nome}
                    </h4>
                    <input
                      type="file"
                      ref={(el) => (fileInputRefs.current[dupla.id] = el)}
                      className="hidden"
                      onChange={(e) => handleFileChange(e, dupla.id)}
                      accept="image/png, image/jpeg"
                    />
                    <button
                      onClick={() => handleLogoButtonClick(dupla.id)}
                      className="text-gray-400 hover:text-white"
                      title="Fazer upload do logo da dupla"
                    >
                      <Upload size={16} />
                    </button>
                  </div>
                  <button
                    onClick={() => onRemoveDupla(dupla.id)}
                    className="text-red-500 hover:text-red-400 p-1"
                  >
                    <Trash2 size={20} />
                  </button>
                </div>
                <div className="space-y-2 mb-3">
                  {/* LINHA CORRIGIDA E MAIS ROBUSTA ABAIXO */}
                  {(dupla.times || [])
                    .sort((a, b) =>
                      (a?.nome_time || "").localeCompare(b?.nome_time || "")
                    )
                    .map((time) => (
                      <div
                        key={time.id}
                        className="bg-gray-700/50 p-2 rounded-lg flex items-center justify-between"
                      >
                        <div className="flex items-center">
                          <button
                            onClick={() => onSetCaptain(time.id, dupla.id)}
                            className="mr-2 p-1 rounded-full hover:bg-gray-600 transition-colors"
                            title="Definir como capitão"
                          >
                            <Star
                              size={16}
                              className={
                                time.is_captain
                                  ? "text-yellow-400 fill-yellow-400"
                                  : "text-gray-500"
                              }
                            />
                          </button>
                          <img
                            src={api.getEscudoUrl(time.escudo_url)}
                            alt={`Escudo do ${time.nome_time}`}
                            className="w-8 h-8 rounded-full mr-2"
                          />
                          <div>
                            <p className="font-semibold text-sm text-white">
                              {time.nome_time}
                            </p>
                            <p className="text-xs text-gray-400">
                              {time.nome_cartoleiro}
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => onRemoveTime(time.id)}
                          className="text-red-500 hover:text-red-400 p-1"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    ))}
                  {(!dupla.times || dupla.times.length === 0) && (
                    <p className="text-gray-400 italic text-sm">
                      Nenhum time adicionado.
                    </p>
                  )}
                </div>
                {(!dupla.times || dupla.times.length < 2) && (
                  <div className="bg-gray-800 p-3 rounded-md">
                    <h5 className="text-md font-semibold mb-2 text-white">
                      Adicionar Time do Cartola
                    </h5>
                    <form
                      onSubmit={(e) => handleSearchSubmit(e, dupla.id)}
                      className="flex items-center space-x-2 mb-3"
                    >
                      <input
                        type="text"
                        value={searchQueries[dupla.id] || ""}
                        onChange={(e) =>
                          setSearchQueries((prev) => ({
                            ...prev,
                            [dupla.id]: e.target.value,
                          }))
                        }
                        placeholder="Buscar time..."
                        className="flex-grow bg-gray-700 p-2 rounded-md text-sm sm:text-base text-white"
                      />
                      <button
                        type="submit"
                        className="bg-blue-600 hover:bg-blue-700 p-2 rounded-lg text-white"
                        disabled={isSearching[dupla.id]}
                      >
                        {isSearching[dupla.id] ? (
                          <Loader className="animate-spin" size={20} />
                        ) : (
                          <Search size={20} />
                        )}
                      </button>
                    </form>
                    {searchErrors[dupla.id] && (
                      <p className="text-red-400 text-sm mb-2">
                        {searchErrors[dupla.id]}
                      </p>
                    )}
                    <div className="space-y-2 max-h-40 overflow-y-auto pr-2">
                      {(searchResults[dupla.id] || []).map((time) => (
                        <div
                          key={time.time_id}
                          className="bg-gray-900/50 p-2 rounded-lg flex items-center justify-between"
                        >
                          <div className="flex items-center">
                            <img
                              src={api.getEscudoUrl(time.url_escudo_png)}
                              alt={`Escudo do ${time.nome}`}
                              className="w-8 h-8 rounded-full mr-2"
                            />
                            <div>
                              <p className="text-sm text-white">{time.nome}</p>
                              <p className="text-xs text-gray-400">
                                {time.nome_cartola}
                              </p>
                            </div>
                          </div>
                          <button
                            onClick={() => handleAddTimeClick(dupla.id, time)}
                            className="bg-green-600 hover:bg-green-700 p-1 rounded-full text-white"
                          >
                            <PlusCircle size={18} />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-8">
          <div className="bg-gray-800 p-4 sm:p-6 rounded-lg shadow-lg">
            <h3 className="text-xl font-bold mb-4 text-white">
              Ações do Desafio
            </h3>
            <div className="space-y-6">
              <div>
                <h4 className="font-semibold mb-2 text-white">
                  Sincronizar Pontuações
                </h4>
                <div className="flex items-center space-x-4 mb-3">
                  <label htmlFor="rodada-select-admin" className="text-white">
                    Rodada:
                  </label>
                  <select
                    id="rodada-select-admin"
                    value={rodadaAdmin}
                    onChange={(e) => setRodadaAdmin(Number(e.target.value))}
                    className="bg-gray-700 text-white p-2 rounded-md"
                  >
                    {[...Array(38).keys()].map((i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  <button
                    onClick={handleFetchScoresClick}
                    className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-3 rounded-lg flex items-center justify-center disabled:bg-gray-500 text-sm"
                    disabled={isFetchingScores}
                  >
                    {isFetchingScores ? (
                      <Loader className="animate-spin mr-2" />
                    ) : (
                      <RefreshCw size={16} className="mr-2" />
                    )}
                    {isFetchingScores ? "A buscar..." : "Buscar Pontos"}
                  </button>
                  <button
                    onClick={() => onResetScoresForRound(rodadaAdmin)}
                    className="w-full bg-orange-700 hover:bg-orange-600 text-white font-bold py-2 px-3 rounded-lg flex items-center justify-center text-sm"
                  >
                    <Trash2 size={16} className="mr-2" />
                    Resetar Rodada
                  </button>
                </div>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-white">
                  Atualizar Dados dos Times
                </h4>
                <p className="text-gray-400 mb-3 text-sm">
                  Busca os nomes e escudos mais recentes de todos os times do
                  desafio.
                </p>
                <button
                  onClick={handleUpdateTeamsClick}
                  className="w-full bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-3 px-4 rounded-lg flex items-center justify-center disabled:bg-gray-500"
                  disabled={isUpdatingTeams}
                >
                  {isUpdatingTeams ? (
                    <Loader className="animate-spin mr-2" />
                  ) : (
                    <Users size={18} className="mr-2" />
                  )}
                  {isUpdatingTeams ? "A atualizar..." : "Atualizar Times"}
                </button>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-red-400">
                  Zona de Perigo
                </h4>
                <p className="text-gray-400 mb-3 text-sm">
                  Apaga permanentemente todas as pontuações e rodadas deste
                  desafio.
                </p>
                <button
                  onClick={onResetScores}
                  className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-4 rounded-lg flex items-center justify-center"
                >
                  <AlertTriangle size={18} className="mr-2" />
                  Resetar Desafio
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
